import { updateVisibilityAttribute as e } from "./constants.js";
import * as t from "react";
import { createOverflowManager as n } from "@fluentui/priority-overflow";
//#region src/shared/overflow/use-overflow-container.ts
function r(r = {}) {
	let i = t.useRef(null), [a] = t.useState(() => typeof window < "u" ? n() : null), o = r.padding ?? 4, s = r.minimumVisible ?? 0, c = r.overflowDirection ?? "end", l = r.hasHiddenItems ?? !1, u = t.useMemo(() => ({
		padding: o,
		minimumVisible: s,
		overflowDirection: c,
		hasHiddenItems: l,
		onUpdateItemVisibility: e,
		onUpdateOverflow: () => void 0
	}), [
		o,
		s,
		c,
		l
	]);
	return t.useLayoutEffect(() => {
		if (!(!a || !i.current)) return a.observe(i.current, { ...u }), () => a.disconnect();
	}, [a, u]), {
		containerRef: i,
		contextValue: t.useMemo(() => ({
			registerItem: (e) => a ? (a.addItem(e), () => a.removeItem(e.id)) : () => void 0,
			registerOverflowMenu: (e) => a ? (a.addOverflowMenu(e), () => a.removeOverflowMenu()) : () => void 0,
			registerDivider: (e) => a ? (a.addDivider(e), () => a.removeDivider(e.groupId)) : () => void 0,
			updateOverflow: () => a?.update(),
			forceUpdateOverflow: () => a?.forceUpdate(),
			containerRef: i,
			getSnapshot: () => a ? a.getSnapshot() : {
				itemVisibility: {},
				groupVisibility: {},
				invisibleItemCount: 0
			},
			subscribe: (e) => a ? a.subscribe(e) : () => void 0
		}), [a])
	};
}
//#endregion
export { r as useOverflowContainer };
